import React, { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Card,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Row,
} from "reactstrap"
import { FormProvider, useFieldArray, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { UFDate, UFInput } from "../../../components/Common/Fields/Input"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  fetchMRRequest,
  postRfq,
} from "../../../services/procurement/materialrequest"
import moment from "moment"
import { fetchProjecrtMaster } from "../../../services/projectManager/projectMaster"
import { useSelector } from "react-redux"
import MaterialRequest from "../../../components/Common/chooseFields/materialrequest"
import SupplierList from "../../../components/Common/chooseFields/supplier"
import { getCode } from "../../../services/inventory"
import { quantity } from "chartist"

const schema = yup.object().shape({
  // material_request_ids: yup
  //   .array()
  //   .of(
  //     yup.object().shape({
  //       value: yup.number().required("MR No is required"),
  //       label: yup.string().required(), // optional, depends on your data structure
  //     })
  //   )
  //   .min(1, "Please select at least one MR No")
  //   .required("MR No is required"),
  material_request_ids: yup.mixed().required("SMR No is required"),
  vendor_ids: yup
    .array()
    .of(
      yup.object().shape({
        value: yup.number().required("Supplier Name is required"),
        label: yup.string().required(), // optional, depends on your data structure
      })
    )
    .min(1, "Please select at least one Supplier")
    .required("Supplier Name is required"),
})

const EditRfq = ({ fromDashboard, projectValue, toggle }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `RFQ${companyname ? ` | ${companyname}` : "MEP -Hub"}`
  const navigate = useNavigate()
  const { id } = useParams()
  const now = moment()
  const [isLoading, setIsLoading] = useState(false)
  const [isDraftLoading, setIsDraftLoading] = useState(false)
  const [projectID, setProjectID] = useState()
  const [compareIds, setCompareIds] = useState([])
  const [viewData, setViewData] = useState([])

  const loggedUser = useSelector(state => state.Login.loggedUser)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const location = useLocation()

  console.log(`location`, location)

  const {
    control,
    handleSubmit,
    watch,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      project_code: null,
      contact_number: "",
      requested_by: "",
      code_edit: 0,
      request_date: moment(now, "YYYY-MM-DD").toDate(),
      delivery_location: null,
      materials: [
        {
          id: "",
          product_id: null,
          quantity: "",
          description: "",
          // priority: null,
          initial_quantity: "",
          // received_quantity: "",
        },
      ],
    },
  })
  // const methods = useForm({
  //   resolver: yupResolver(schema),
  //   mode: "onChange",
  //   shouldFocusError: true,
  // })
  const {
    fields: materialFields,
    append: materialAppend,
    remove: materialRemove,
  } = useFieldArray({
    control,
    name: "materials",
  })

  const handleRegistration = async data => {
    console.log(`data mmmm`, data)

    // const mrIds = data?.material_request_ids?.map(dt => dt?.value)
    const mrIds = data?.material_request_ids?.value
    const vendorIds = data?.vendor_ids?.map(dt => dt?.value)
    const materialArr = data?.materials?.map(dt => ({
      material_id: dt?.material_id,
      unit_id: dt?.unit_id,
      quantity: dt?.quantity,
    }))
    try {
      setIsLoading(true)
      const update = await postRfq({
        material_request_ids: mrIds,
        vendor_ids: vendorIds,
        code: data?.code,
        date: moment(data?.request_date).format("YYYY-MM-DD"),
        materials: materialArr,
      })
      if (fromDashboard) {
        toggle()
      } else {
        navigate("/procurement-rfq")
      }
      toastSuccess(update?.message)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      setIsDraftLoading(false)
    }
  }

  useEffect(() => {
    if (fromDashboard) {
      setValue("project_code", projectValue)
      fetchProjectData(id)
      setProjectID(id)
    }
    const fetchMrEdit = async id => {
      const responce = await fetchMRRequest(id)
      console.log(`responce edit`, responce)
      const materialsArr = responce?.data?.materials?.map(dt => ({
        product_id: {
          label: dt?.product?.product_code,
          value: dt?.product?.id,
        },
        quantity: dt?.requested_quantity,
        description: dt?.product?.description,
      }))
      reset({
        ...responce?.data,
        project_code: {
          label: responce?.data?.project?.project_code,
          value: responce?.data?.project?.id,
        },
        project_name: responce?.data?.project?.project_name,
        exp_Delivery_date: responce?.data?.exp_Delivery_date,
        material_req: materialsArr,
      })
    }
    const getUniqueCode = async (code, modal, type) => {
      const response = await getCode(code, modal, type)
      if (!id) {
        setValue("code", response?.code?.code)
      }
      setValue("code_edit", response?.code?.manualoverride)
    }

    if (id) {
      fetchMrEdit(id)
    }
    // if (!id) {
    getUniqueCode("code", "RFQModel", "RFQModel")
    // }
  }, [fromDashboard, id])

  const fetchProjectData = async idData => {
    const response = await fetchProjecrtMaster(idData)
    if (idData == response.data?.id) {
      const Requestarray = response.data?.project_material
        ?.map(dt => {
          const projectMrQuantitySum = dt.project_mr.reduce(
            (total, mr) => total + parseFloat(mr.quantity),
            0
          )

          const alreadyReceived = dt.project_mr.length
            ? dt.quantity - projectMrQuantitySum
            : 0
          const balanceQty = dt.project_mr.length ? projectMrQuantitySum : 0
          const quantity = dt.project_mr.length ? alreadyReceived : dt.quantity
          return {
            product_id: {
              value: dt?.product_code?.id,
              label: dt?.product_code?.product_code,
              storeCount: dt?.products?.storeCount,
            },
            description: dt?.description,
            quantity: quantity,
            initial_quantity: dt?.quantity,
            received_quantity: balanceQty,
            unit_id: dt?.unit?.id,
          }
        })
        .filter(item => item.quantity !== 0)
      const previousDatas = getValues()
      reset({
        ...previousDatas,
        project_name: response.data?.project_name,
        material_req: Requestarray,
        delivery_location: response.data?.location?.name,
      })
    }
  }

  useEffect(() => {
    if (location?.state?.id) {
      console.log(`locationnnnn`, location)

      reset({
        material_request_ids: {
          label: location?.state?.code,
          value: location?.state?.id,
        },
      })
      handleMatrial(location?.state?.id)
    }
  }, [location])

  console.log(`viewData`, viewData)

  useEffect(() => {
    if (!viewData || viewData.length === 0) return

    // Grouping products
    const groupedProductsObj = viewData.reduce((acc, item) => {
      const productId = item.product?.id
      if (!productId) return acc

      if (!acc[productId]) {
        acc[productId] = {
          product: item.product,
          total_requested_quantity: 0,
        }
      }

      acc[productId].total_requested_quantity += Number(
        item.requested_quantity || 0
      )
      return acc
    }, {})

    // Convert to array and map to form-compatible structure
    const productFormData = Object.values(groupedProductsObj).map(
      productItem => ({
        material_id: productItem.product.id,
        product_code: productItem.product.product_code,
        description: productItem.product.description,
        unit: productItem.product.unit?.unit_code || "",
        unit_id: productItem.product.unit?.id || "",
        requested_quantity: productItem.total_requested_quantity,
        quantity: productItem.total_requested_quantity,
        store_available_quantity:
          productItem.product.storeCount > 0
            ? productItem.product.storeCount
            : 0,
      })
    )

    // Set the entire products array in form
    setValue("materials", productFormData)
  }, [viewData, setValue])

  const handleMatrial = async id => {
    // const selectedIds = watch(`material_request_ids`)
    // // let compareIds = []; // Initialize compareIds
    // const ids = selectedIds?.map(dt => dt?.value)

    // // Filter out IDs that are not in compareIds
    // const newIds = ids?.filter(id => !compareIds.includes(id))

    // if (newIds && newIds.length > 0) {
      // try {
        const response = await fetchMRRequest(id)
        // setCompareIds([...compareIds, ...newIds])

        setViewData(response?.data?.materials)
      // } catch (error) {
      //   console.error(`Error fetching material requests:`, error)
      // }
    // } else {
    //   setViewData(prevData =>
    //     prevData.filter(item => ids.includes(item.material_request?.id))
    //   )
    //   setCompareIds(prevIds => prevIds.filter(id => ids.includes(id)))
    // }
  }

  return (
    <React.Fragment>
      <div
        className={`${
          fromDashboard ? "pt-0 dashboard-page-content" : "page-content"
        }`}
      >
        <div className="container-fluid">
          <FormProvider>
            <Form
              id={`request-form`}
              onSubmit={handleSubmit(handleRegistration)}
            >
              <div className="sticky-top w-100">
                <div className="d-flex justify-content-between pe-3">
                  {!fromDashboard ? (
                    <Breadcrumbs
                      title="Procurement"
                      breadcrumbObject={[
                        { title: "Procurement", link: "/procurement" },
                        { title: crumb || "Masters", link: "/procurement" },
                        {
                          title: "RFQ",
                          link: "/procurement-rfq",
                        },
                        {
                          title: id ? "Edit RFQ" : "Add RFQ",
                          link: "",
                        },
                      ]}
                    />
                  ) : (
                    <div></div>
                  )}

                  <LoadingButton
                    form={`request-form`}
                    color={"primary"}
                    loading={isLoading}
                    disabled={isLoading}
                    className={"px-2 mb-3 ms-2 btn btn-primary"}
                    type="submit"
                  >
                    {fromDashboard ? "Save" : id ? "Update" : "Save & Share"}
                  </LoadingButton>
                </div>
              </div>
              <Container fluid className="ps-lg-0">
                <Card className="invoice-main-card p-3 pt-4">
                  <Row className="mb-1 mt-2">
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>RFQ Code</Label>
                        <UFInput
                          control={control}
                          placeholder=""
                          name={"code"}
                          invalid={!!errors.code}
                          disabled={
                            watch("code_edit") == 0 ||
                            watch("code_edit") == undefined
                              ? true
                              : false
                          }
                        />
                        <FormFeedback invalid>
                          {errors.code?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          SMR No<span className="mandatory">*</span>
                        </Label>
                        <MaterialRequest
                          control={control}
                          name={"material_request_ids"}
                          placeholder={"Select the MR No"}
                          target={fromDashboard ? ".modal" : "body"}
                          // isMultiple={true}
                          onSelectChange={e => handleMatrial(e?.id)}
                          isApproved={true}
                          clearable={false}
                        />
                        <FormFeedback invalid>
                          {errors.material_request_ids?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>

                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Date <span className="mandatory">*</span>
                        </Label>
                        <UFDate
                          control={control}
                          name={"request_date"}
                          invalid={!!errors.request_date}
                        />
                        <FormFeedback invalid>
                          {errors.request_date?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Supplier Name <span className="mandatory">*</span>
                        </Label>
                        <SupplierList
                          control={control}
                          placeholder="Select the Supplier Name"
                          name={"vendor_ids"}
                          invalid={!!errors.vendor_ids}
                          target=".modal"
                          isMultiple={true}
                        />
                        <FormFeedback invalid>
                          {errors.vendor_ids?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                  {viewData?.length ? (
                    <>
                      <hr className="m-0" />
                      <Row className="py-2 mt-1">
                        <h5 className="edittheamtitle">
                          Request for Quote Details
                        </h5>
                      </Row>
                      <Row className="mb-4">
                        <Col lg={12}>
                          <table className="estimation-table mb-4">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Product Name</th>
                                <th>Requested Qty.</th>
                                {/* <th>Store Available Qty.</th> */}
                                <th>Quantity </th>
                              </tr>
                            </thead>
                            <tbody>
                              {materialFields.map((item, index) => (
                                <tr key={`materialFields${item?.id || index}`}>
                                  <td className="ps-1">
                                    <div className="fs-13">{index + 1}</div>
                                  </td>
                                  <td className="ps-1">
                                    <div className="fs-13">
                                      {item?.product_code
                                        ? `${item?.product_code} ${
                                            item?.description
                                              ? `- ${item?.description}`
                                              : ""
                                          }`
                                        : "-"}
                                    </div>
                                  </td>
                                  {/* <td className="ps-1">
                                    <div className="fs-13">
                                      {item?.material_request?.code
                                        ? item?.material_request?.code
                                        : "-"}
                                    </div>
                                  </td> */}
                                  <td className="ps-1">
                                    <div className="fs-13">
                                      {item?.requested_quantity
                                        ? item?.requested_quantity
                                        : "-"}
                                    </div>
                                  </td>
                                  {/* <td className="ps-1">
                                    <div className="fs-13">
                                      {item?.store_available_quantity
                                        ? item?.store_available_quantity
                                        : 0}
                                    </div>
                                  </td> */}
                                  <td className="ps-1">
                                    <UFInput
                                      control={control}
                                      placeholder="Quantity"
                                      name={`materials.${index}.quantity`}
                                      disabled={true}
                                      invalid={
                                        !!errors?.material_req?.[index]
                                          ?.quantity
                                      }
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <></>
                  )}
                </Card>
              </Container>
            </Form>
          </FormProvider>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditRfq
